export default {
  title:           'Autorização para Terceiro',
  fillFieldsBelow: 'Antes de seguir com o pedido, precisamos fazer algumas validações. Por favor preencha os campos abaixo',
  authUserData:    'Preencha aqui os <strong>seus</strong> dados',
  userData:        'Preencha aqui os dados da pessoa que você está representando',
  sendDocuments:   'Por favor envie os documentos abaixo para o email <a href="mailto:meusdados@simplic.com.br">meusdados@simplic.com.br</a>.',
  doc1:            'Seu Documento de Identidade',
  doc2:            'Procuração Autenticada',
  doc3:            'Documento de Identidade da pessoa que você está representando.',
  docPost:         'Lembre-se de que a procuração deve ser autenticada em cartório para ter validade.',
  validationInfo:  'O pedido será efetuato após a validação dos documentos. Um email será enviado para o titular da conta com a resposta do seu pedido.',
  agree:           'Declaro que os dados informados acima são verdadeiros',
};
